/* eslint-disable no-unused-vars */
import { create } from 'zustand';
// import { httpRequest, routeTo, localStorageKeys} from '@hc/utils';

export const useRouting = create((set, get) => ({
  route: null,
  state: null,
}));
